import React, { useEffect, useState } from "react";
import api from "../api/api";
import {
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckIcon from "@mui/icons-material/Check";

export default function AdminFeedbackPage() {
  const [feedbacks, setFeedbacks] = useState([]);

  const loadFeedback = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await api.get("/feedback", {
          headers: {
              Authorization: `Bearer ${token}`,
          },
      });
      setFeedbacks(res.data);
    } catch (error) {
      console.log("Error cargando feedback:", error);
    }
  };

  const deleteFeedback = async (id) => {
    if (!window.confirm("¿Eliminar feedback?")) return;

    try {
      await api.delete(`/feedback/${id}`);
      loadFeedback();
    } catch (error) {
      console.log("Error eliminando feedback:", error);
    }
  };

  useEffect(() => {
    loadFeedback();
  }, []);

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" sx={{ mt: 5,mb: 3, fontWeight: "bold", color: "#00796B" }}>
        Panel de Feedback
      </Typography>

      <Card sx={{ padding: 2 }}>
        <CardContent>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><b>ID</b></TableCell>
                <TableCell><b>Nombre</b></TableCell>
                <TableCell><b>Email</b></TableCell>
                <TableCell><b>Mensaje</b></TableCell>
                <TableCell><b>Fecha</b></TableCell>
                <TableCell><b>Acciones</b></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {feedbacks.map((f) => (
                <TableRow key={f.id}>
                  <TableCell>{f.id}</TableCell>
                  <TableCell>{f.name}</TableCell>
                  <TableCell>{f.email}</TableCell>
                  <TableCell>{f.suggestion}</TableCell>
                  <TableCell>{new Date(f.created_at).toLocaleString()}</TableCell>
                  <TableCell>
                    <IconButton onClick={() => deleteFeedback(f.id)} color="error">
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </Box>
  );
}
